import { Controller } from "@hotwired/stimulus";
import { decode } from "blurhash";

export default class extends Controller {
  connect() {
    this.canvases = {};

    this.element.querySelectorAll("[data-blurhash]").forEach((element, idx) => {
      if (!element.dataset.blurhash) return;

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const container = document.createElement("div");
      const parentElement = element.parentElement;
      const width = Math.round(Math.min(...this.excludeNaN([parentElement.offsetWidth, Number(element.dataset.width)])), 0);
      const aspectRatio = this.excludeNaN([Number(element.dataset.aspectRatio)])[0] || 1;
      const height = Math.round(width / aspectRatio, 0);
      const imageData = ctx.createImageData(width, height);
      const pixels = decode(element.dataset.blurhash, width, height);

      container.style.width = `${width}px`;
      container.style.height = `${height}px`;
      canvas.width = width;
      canvas.height = height;
      element.width = width;
      element.height = height;

      container.style.position = "relative";
      element.style.position = "absolute";
      element.style.top = "0";
      element.style.left = "0";

      container.appendChild(canvas);
      container.appendChild(element);

      parentElement.appendChild(container);

      imageData.data.set(pixels);
      ctx.putImageData(imageData, 0, 0);

      this.canvases[idx] = canvas;

      element.dataset.blurhashCanvasIdParam = idx;
      element.dataset.action = "load->blurhash#removeCanvas";
    });
  }

  removeCanvas({ params: { canvasId } }) {
    this.canvases[canvasId]?.remove();
  }

  excludeNaN(array) {
    return array.filter(x => !isNaN(x));
  }
}
